import React, {useEffect, useState} from 'react';
import {Button, Stack} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {useObservable} from '@ngneat/react-rxjs';
import {finalize} from 'rxjs';
import {useSnackbar} from 'notistack';

import {supplierDetailsQuery} from '@store/suppliers/details';
import {clientsServicesQuery, clientsServicesService} from '@store/clients/services';

import {Add, Download, GroupAction} from '@icons/index';
import ClientContractedServicesTable
  from '@screens/admin/clients/details/contractedServices/ClientContractedServices.table';
import CreateServiceDrawer from '@screens/admin/clients/details/contractedServices/manageService/CreateService.drawer';
import { clientDetailsQuery } from '@store/clients/details';
import { ClientHead } from '@store/clients/clients.model';



const ClientContractedServicesTab = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const {enqueueSnackbar} = useSnackbar();

  const [CSVLoading, setCSVLoading] = useState(false);

  const [selectedClientsServices] = useObservable(clientsServicesQuery.selectedClientsServices$);
  const [showAddService, setShowAddService] = useState(false);

  const [{ headOffice, loading }] = useObservable(clientDetailsQuery.clientDetails$);

  const [fromClient, setFromClient] = useState({id: 0, name: ''} as ClientHead);

  useEffect(() => {
    if (headOffice.id) {
      setFromClient({id: headOffice.id, name: headOffice.name});
    }
  }
  , [headOffice]);


  const handleExportCSV = () => {
    setCSVLoading(true);
    clientsServicesService.getClientsServicesCSV()
      .pipe(finalize(() => setCSVLoading(false)))
      .subscribe({
        error: (err) => enqueueSnackbar(err.text, err.options),
      });
  };

  return (
    <Stack flex={1} mt="-35px" spacing={2}>
      <Stack direction="row" alignItems="center" justifyContent="flex-end">
        <Stack direction="row" alignItems="center" spacing={2}>
          <Button
            variant="outlined" color="primary"
            startIcon={<GroupAction/>}
            disabled={!selectedClientsServices.length}>
            {t('global.groupedAction')}
          </Button>
          <Button
            variant="outlined" color="primary"
            disabled={CSVLoading}
            onClick={handleExportCSV}
            startIcon={<Download/>}>
            {t('global.exportCSV')}
          </Button>

          {!supplierDetailsQuery.isArchived && (
            <>
            <Button
              variant="contained" color="primary"
              onClick={() => setShowAddService(true)}
              startIcon={<Add/>}>
              {t('clients.details.contractedServices.addButton')}
            </Button>
            </>
          )}
        </Stack>
      </Stack>
      <ClientContractedServicesTable/>
      { showAddService && (<CreateServiceDrawer fromClient={fromClient} handleClose={() => setShowAddService(false)} />) }
    </Stack>
  );
};

export default ClientContractedServicesTab;
